import DirectionsWalkIcon from "@material-ui/icons/DirectionsWalk";
import AdminMailConfigEdit from "./edit";
import AdminMailConfigList from "./list";

export default {
    list: AdminMailConfigList,
    edit: AdminMailConfigEdit,
    icon: DirectionsWalkIcon,
};
